<template>
  <div>
    <b-tabs
      class="mt-1"
      content-class="mt-2"
      v-on:input="selectSource"
      v-if="filteredStreams.length > 0"
    >
      <b-tab v-for="stream in filteredStreams" :key="`${stream.data_table}--tab`" lazy>
        <template #title>
          <small>{{ stream.stream_method }}-{{ stream.stream_rd }}</small>
        </template>
        <b-button-toolbar
          class="mb-1"
          aria-label="Toolbar for controlling the realtime plot"
        >
          <b-button-group size="sm" class="mr-1">
            <b-button @click="startFeed" :disabled="feedStarted"
              ><i class="fas fa-play"></i> Start</b-button
            >
            <b-button @click="stopFeed" :disabled="!feedStarted"
              ><i class="fas fa-stop"></i> Stop</b-button
            >
          </b-button-group>
        </b-button-toolbar>
        <b-alert
          :show="noStream"
          dismissible
          fade
          variant="danger"
        >
          Sorry!
          It appears that this instrument is not currently streaming data.
          Please try again later.
        </b-alert>
        <b-overlay :show="!feedStarted">
          <rt-plot
            :stream="stream"
            :dataStreaming="streamData"
            :feedStarted="feedStarted"
          ></rt-plot>
          <template #overlay>
            <div class="text-center">
              <i class="fas fa-chart-line rt-control"></i>
              <br />
              Realtime feed of the instrument stream has not started. Please press
              the <i class="fas fa-play"></i> start button on the top left of this
              plot.
            </div>
          </template>
        </b-overlay>
      </b-tab>
    </b-tabs>
    <p v-if="filteredStreams.length === 0">
      This instrument is not currently streaming from the Interactive Oceans system.
    </p>
  </div>
</template>

<script>
import _ from 'lodash';
import RTPlotVue from './RTPlot';
import { APIREALTIME, APIREALTIMEBASE } from '../../utils/constants';

export default {
  props: ['streams', 'visible'],
  components: {
    'rt-plot': RTPlotVue,
  },
  data() {
    return {
      currentSocket: null,
      currentData: null,
      streamData: {},

      feedStarted: false,
      currentStream: {},
      noStream: false,
      emptyCount: 0,
    };
  },
  computed: {
    filteredStreams() {
      return _.filter(this.streams, ['active', true]);
    },
  },
  methods: {
    createSocket(source) {
      let baseDomain;
      let wsprotocol;
      if (APIREALTIMEBASE.includes('https://')) {
        baseDomain = APIREALTIMEBASE.replace('https://', '');
        wsprotocol = 'wss:';
      } else {
        baseDomain = APIREALTIMEBASE.replace('http://', '');
        wsprotocol = 'ws:';
      }
      const socket = new WebSocket(`${wsprotocol}//${baseDomain}/${APIREALTIME}/${source}`);
      socket.onmessage = (event) => {
        const dataObj = JSON.parse(event.data);
        if (!_.has(dataObj, 'status')) {
          // Store the data object to current data for processing
          this.currentData = dataObj;
        } else if (['accepted', 'success'].includes(dataObj.status)) {
          // eslint-disable-next-line no-console
          console.log(`${source}: ${dataObj.status}`);
        }
      };
      this.currentSocket = socket;
    },
    closeSocket() {
      if (this.currentSocket) {
        this.currentSocket.close(1000, 'Done.');
      }
    },
    selectSource(tabIndex) {
      this.closeSocket();
      this.currentStream = this.filteredStreams[tabIndex];
    },
    startFeed() {
      this.feedStarted = true;
      this.noStream = false;
      this.createSocket(this.currentStream.data_table);
    },
    stopFeed() {
      this.feedStarted = false;
      this.closeSocket();
      this.streamData = {};
      this.emptyCount = 0;
    },
    customizer(objValue, srcValue) {
      if (_.isArray(objValue)) {
        return objValue.concat(srcValue);
      }
      return [];
    },
  },
  watch: {
    currentData(value) {
      let cleanedObj;
      // const localStream = _.defaultsDeep({}, this.streamData);
      const dataPoint = value.data;
      if (dataPoint !== null) {
        if (_.has(dataPoint, 'time')) {
          /* Cleans up the stream data point
          to not include timestamp and string */
          const timeArr = dataPoint.time;
          const otherArrs = _.pickBy(dataPoint, (val, key) => {
            if (key !== 'time' && !key.includes('timestamp') && !key.includes('string') && !key.includes('coefficient')) {
              const filteredVals = _.filter(val, (v) => !_.isInteger(v));
              return filteredVals.length > 0;
            }
            return false;
          });
          cleanedObj = {
            time: timeArr,
            ...otherArrs,
          };
          const mergedData = _.mergeWith({ ...this.streamData }, cleanedObj, this.customizer);
          if (!_.isEmpty(mergedData)) {
            this.streamData = _.mapValues(mergedData, (arr) => {
              if (arr) {
                return arr.slice(-900); // Keep 15 minutes of data
              }
              return [];
            });
          }
        }
      } else {
        this.emptyCount += 1;
      }
    },
    emptyCount(value) {
      if (value === 10) {
        this.noStream = true;
        this.stopFeed();
      }
    },
    visible(value) {
      if (this.feedStarted && value === false) {
        this.stopFeed();
      }
    },
  },
};
</script>

<style>
.rt-container {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.rt-control {
  font-size: 5rem;
}
</style>
